import React from 'react';
import cn from 'classnames';
import CellDataContainer from '../CellDataContainer/CellDataContainer';
import CellText from '../CellText/CellText';
import getName from '../../../helpers/getName';
import WorkerCell from '../../WorkerCell/WorkerCell';
import { workerKeys } from '../../WorkerCell/constants';
import styles from './RequestMasterAndExecuter.module.scss';

const RequestMasterAndExecuter = ({ request = {}, canChange = true }) => {
  const master = getName(request.master) || '-';
  const executer = getName(request.executer) || '-';

  const contentArr = [
    {
      key: workerKeys.master,
      name: master,
      speciality: request.master?.specialityName,
      considerPaidId: true,
    },
    {
      key: workerKeys.executor,
      name: executer,
      speciality: request.executer?.specialityName,
      considerPaidId: false,
    },
  ];

  return (
    <CellDataContainer>
      {contentArr.map((content) => (
        <WorkerCell
          key={content.key}
          canChange={canChange}
          request={request}
          workerKey={content.key}
          considerPaidId={content.considerPaidId}
          renderContent={({ withCursor }) => (
            <div
              className={cn(styles.contentWrap, {
                [styles.active]: withCursor,
              })}
            >
              {content.speciality && (
                <CellText className={styles.speciality}>
                  {content.speciality}
                </CellText>
              )}
              <CellText>{content.name}</CellText>
            </div>
          )}
        />
      ))}
    </CellDataContainer>
  );
};

export default RequestMasterAndExecuter;
